import type { UserTrackingStatus } from '@/types/trackingStatus'
import { DEFAULT_WORKING_HOURS } from '@/types/workingHours'

export function defaultTrackingStatus(userId: string): UserTrackingStatus {
    return {
        userId,
        status: 'no_data_today',
        lastUpdate: null,
        workingHours: { ...DEFAULT_WORKING_HOURS, source: 'default' },
        isWithinWorkingHours: true,
        geoTrackingDisabled: false,
        minutesSinceLastUpdate: null,
    }
}
